// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button } from 'semantic-ui-react';
// local
// actions
import { closeModal } from 'app/redux/actions/editConfirm/confirmModal';

class ConfirmSendModal extends Component {
    componentWillUnmount = () => this.onClose();
    onClose = () => this.props.dispatch(closeModal());

    onClickConfirm = () => {
        this.onClose();
        const { onClickConfirm } = this.props;
        if (onClickConfirm) {
            const { data } = this.props.modalConfirmEditSend;
            onClickConfirm(data);
        }
    };

    render() {
        const { isOpened, data } = this.props.modalConfirmEditSend;
        return (
            <Modal open={isOpened} onClose={this.onClose}>
                <Modal.Content>
                    <p className="content text-center">
                        Foi feita alteração(ões) em <span className="bold">{data && Array.isArray(data) ? data.length : 0}</span> paciente(s). Tem certeza que
                        deseja prosseguir?
                    </p>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={this.onClose}>Cancelar</Button>
                    <Button onClick={this.onClickConfirm} className="highlight">
                        Sim
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }
}

ConfirmSendModal.propTypes = {
    modalConfirmEditSend: PropTypes.object,
    onClickConfirm: PropTypes.func,
    dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
    modalConfirmEditSend: state.modalConfirmEditSend,
});
export default connect(mapStateToProps)(ConfirmSendModal);
